import { ChakraProps } from '@aloft/toolkit-sui/chakra';

export function getCellStyles(): ChakraProps {
  const styles: ChakraProps = {
    paddingY: 0.5,
    backgroundColor: 'textOffset',

    borderBottom: '1px solid',
    borderColor: 'strokeDefault',
  };

  return styles;
}
